<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    role="status"
    class="w-5 h-5 animate-spin absolute"
    v-bind="$attrs"
    :class="{ invisible: !visible }"
  >
    <path
      d="M12.0112 0.413574C18.1794 0.413586 23.2213 5.22879 23.5864 11.3052H21.5806C21.2188 6.33431 17.0744 2.41359 12.0112 2.41357C6.71067 2.41375 2.41375 6.71067 2.41357 12.0112C2.41359 17.0744 6.33431 21.2188 11.3052 21.5806V23.5864C5.22879 23.2213 0.413586 18.1794 0.413574 12.0112C0.413747 5.6061 5.6061 0.413747 12.0112 0.413574Z"
      fill="#52525B"
    />
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = defineProps<{
  visible?: boolean
}>()

const visible = computed(() => props.visible ?? true)
</script>
